var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon06Launch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 9.8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.2-2.5-2.5-2.5zm0 3.5c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1zm8.8 8.3L21.6 17v-5.1c0-3.1-1.9-5.8-3.7-7.1-.3-.2-.8-.4-1.3-.4s-1 .2-1.3.4c-1.8 1.3-3.6 3.9-3.7 7V17l-3.8 4.6c-.6.8-.9 1.7-.9 2.6v5.5c0 .3.2.6.5.7.1 0 .2.1.3.1.2 0 .4-.1.5-.2l3.7-3.8c.3.6 1 1 1.7 1h2.3v2.3c0 .4.3.8.8.8s.8-.3.8-.8v-2.3h2.3c.7 0 1.4-.4 1.7-1l3.7 3.9c.1.1.3.2.5.2.1 0 .2 0 .3-.1.3-.1.5-.4.5-.7v-5.5c-.2-1-.5-1.9-1.1-2.7zM8.3 24.3c0-.6.2-1.2.6-1.7l2.6-3.2v5.1l-3.2 3.3v-3.5zm11.8 1.1c0 .3-.2.5-.5.5h-2.3v-7.3c0-.4-.3-.8-.8-.8s-.8.3-.8.8v7.3h-2.3c-.3 0-.5-.2-.5-.5v-.5V12v-.1c0-2.6 1.5-4.8 3-5.9.1-.1.4-.2.5-.2.1 0 .3.1.4.2 1.5 1.1 3 3.3 3 5.9v13.5zm4.7 2.5l-3.2-3.4v-5.1l2.6 3.2c.4.5.6 1.1.6 1.7v3.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon06Launch);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_06_Launch.89a59a5b.svg";
export { ForwardRef as ReactComponent };